import { DL_ENABLED } from "../../../config/features";

/**
 * The products a branch can be given access to.
 *
 * Stored on branch.accessType as a comma-separated string - a plain STRING
 * column with no enum (backend/models/branch.js), so adding a product here
 * needs no migration. It is read back in AdminAuthProvider and matched by
 * Sidebar's hasLoanAccess, and on mobile by BottomTab's hasLoanAccess.
 *
 * Defined here once because BOTH the add-branch and edit-branch modals need it.
 * They previously could not drift only because the edit modal had no list at
 * all - it used a free-text box that never saved. See CLAUDE.md section 3.
 *
 * "Daily Loan" matches member_details.loanType and backend/constants/loanTypes.js.
 * Note "JLG" below is a fourth spelling of a product the rest of the system
 * calls "JLG Loan" - it is what existing branch rows already hold, so it stays.
 * Do not add a fifth.
 *
 * "Daily Loan" is dropped from this list while DL_ENABLED is false, so an
 * admin cannot grant a branch access to a product the UI is hiding this
 * release. A branch that already holds "Daily Loan" from before is untouched -
 * this only controls what a *new* selection in the modal can add.
 */
export const accessTypeOptions = [
  { value: "Business Loan", label: "Business Loan" },
  { value: "JLG", label: "JLG" },
  { value: "GP Loan", label: "GP Loan" },
  ...(DL_ENABLED ? [{ value: "Daily Loan", label: "Daily Loan" }] : []),
];

/**
 * The stored comma-separated string -> react-select option objects.
 *
 * Values not in accessTypeOptions are kept rather than dropped, so opening the
 * edit modal on a branch carrying an older spelling cannot silently strip its
 * access on save.
 */
export const accessTypeStringToOptions = (accessType) =>
  (accessType || "")
    .split(",")
    .map((type) => type.trim())
    .filter(Boolean)
    .map(
      (value) =>
        accessTypeOptions.find((option) => option.value === value) || {
          value,
          label: value,
        }
    );

/** react-select option objects -> the stored comma-separated string. */
export const accessTypeOptionsToString = (options) =>
  (options || []).map((option) => option.value).join(", ");
